module.exports = {
    help: {
        pages: 4,
        pageNameFormat: "res/help/%03d.jpg",
        priceFontName: "./small_font",
        click: "res/sounds/help/help_click",
        //backgroundMusic: "res/sounds/help/background",
        pricetable: [
            {
                symbol: 0,
                wins: [5, 4, 3, 2],
                position: {x: 251, y: 166},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
            {
                symbol: 1,
                wins: [5, 4, 3, 2],
                position: {x: 588, y: 166},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
            {
                symbol: 2,
                wins: [5, 4, 3],
                position: {x: 930, y: 183},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
            {
                symbol: 3,
                wins: [5, 4, 3],
                position: {x: 251, y: 337},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
            {
                symbol: 4,
                wins: [5, 4, 3],
                position: {x: 589, y: 337},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
            {
                symbol: 5,
                wins: [5, 4, 3],
                position: {x: 930, y: 339},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
            {
                symbol: 6,
                wins: [5, 4, 3],
                position: {x: 251, y: 494},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
            {
                symbol: 9,
                wins: [5, 4, 3],
                position: {x: 589, y: 494},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
            {
                symbol: 10,
                wins: [5, 4, 3],
                position: {x: 930, y: 494},
                offset: {width: 0, height: 31},
                align: 'middle'
            },
        ]
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/help-config.js
// module id = 13
// module chunks = 0